import { solutionsStructure as ptSt, servicesData as ptData, marketsData as ptMarkets, MarketKey, ScopeKey, ServiceListItem, MarketStructure, ServiceData, MarketData } from './solutions.pt';
import { solutionsStructure as esSt, servicesData as esData, marketsData as esMarkets } from './solutions.es';
import { solutionsStructure as enSt, servicesData as enData, marketsData as enMarkets } from './solutions.en';

export const getSolutionsStructure = (lang: string): MarketStructure[] => lang === 'es' ? esSt : lang === 'en' ? enSt : ptSt;
export const getServicesData = (lang: string): Record<string, ServiceData> => lang === 'es' ? esData : lang === 'en' ? enData : ptData;
export const getMarketsData = (lang: string): MarketData[] => lang === 'es' ? esMarkets : lang === 'en' ? enMarkets : ptMarkets;

// For compatibility where static import is needed (maybe default to pt)
export const solutionsStructure = ptSt;
export const servicesData = ptData;
export const marketsData = ptMarkets;
export type { MarketKey, ScopeKey, ServiceListItem, MarketStructure, ServiceData, MarketData };
